import React from "react";
import { BsPlusCircleFill } from "@react-icons/all-files/bs/BsPlusCircleFill";

import { classNames } from "repoV2/utils/common/render/classNames";
import Slot from "./components/Slot/Slot";
import styles from "./slotDropdown.module.scss";
import useSlotDropdown from "./useSlotDropdown";
import { ISlotDropdownProps } from "./SlotDropdown";

const SlotDropdown = (props: ISlotDropdownProps) => {
    const { selectedSlotsIndexs, addSlot, hideAddSlot, isMobile, slotParams } =
        useSlotDropdown(props);
    return (
        <div className={styles.root}>
            {selectedSlotsIndexs.map(i => (
                <Slot {...slotParams} index={i} key={i} />
            ))}
            {hideAddSlot ? null : (
                <div
                    className={classNames(
                        styles.addSlot,
                        !isMobile && styles.compactEventPageContainer
                    )}
                    title="Add Slot"
                    onClick={addSlot}
                >
                    Add slot&nbsp;&nbsp;
                    <BsPlusCircleFill className={styles.addIcon} />
                </div>
            )}
        </div>
    );
};
export default SlotDropdown;
